import { SvgIconNames } from '@design/design-tokens/iconography/SvgIcons';

export const getEarningsInsightIconName = (
  isPreview: boolean,
  isBordered: boolean
): SvgIconNames => {
  if (isPreview) {
    return isBordered ? 'EarningsPreview' : 'EarningsPreviewBorderless';
  }

  return isBordered ? 'EarningsRecap' : 'EarningsRecapBorderless';
};
